const i = {
  de: "de",
  dk: "da",
  en: "en",
  it: "it",
  es: "es",
  fr: "fr"
}, p = "en", x = Object.keys(i), z = Object.values(i), s = ["de"], a = (e) => x.includes(e), U = (e) => z.includes(e), h = (e) => s.includes(e), d = (e) => {
  var t;
  const n = e ?? ((t = globalThis.location) == null ? void 0 : t.origin) ?? "";
  return s.find(
    (o) => n.endsWith(`.${o}`)
  );
}, u = (e) => {
  var r;
  const n = e ?? ((r = globalThis.location) == null ? void 0 : r.pathname) ?? "", [t, o] = n.split("/");
  return o;
}, P = () => d() ? "/" : `/${f()}`, f = () => {
  const e = d(), n = u();
  return e || (a(n) ? n : p);
}, m = () => i[f()], L = (e) => {
  const n = u(e);
  return a(n);
}, T = (e) => {
  if (!L(e)) return e;
  const [, ...n] = e.split("/").filter(Boolean);
  return "/" + n.join("/");
}, $ = (e, n) => {
  const t = P(), o = t === "/" || L(e) ? e : `${t}${e}`;
  if (!n)
    return o;
  const r = new URLSearchParams(
    Object.entries(n).reduce((l, [g, c]) => c ? {
      ...l,
      // Convert number and boolean to string
      [g]: String(c)
    } : l, {})
  );
  return `${o}?${r.toString()}`;
};
export {
  p as defaultLocale,
  d as findLocalizedTopLevelDomain,
  m as getCurrentLocale,
  f as getCurrentUrlPrefix,
  P as getLocalizedBaseUrl,
  u as getUrlPrefix,
  U as isValidLocale,
  h as isValidLocalizedTopLevelDomain,
  a as isValidUrlPrefix,
  i as localeMap,
  z as locales,
  $ as localizeUrl,
  s as localizedTopLevelDomains,
  T as unlocalizePathname,
  x as urlPrefixes
};
//# sourceMappingURL=locale.js.map
